import _ from 'underscore';
import PropTypes from 'prop-types';

export const getStyles = () => ({
  dialog: {
    '& .ms-Dialog-actionsRight': {
      textAlign: 'left',
      marginLeft: '-4px',
    },
    '& .panel-body': {
      paddingLeft: 0,
    },
    '& .panel-footer': {
      padding: 0,
      backgroundColor: 'white',
      borderTopColor: 'white',
    },
    '& .addressLabel': {
      paddingLeft: 0,
    },
    '& .accountsLabel': {
      paddingLeft: 0,
    },
  },
  '@global': {
    '.ms-Layer--fixed + .ms-Layer--fixed .lightbox': {
      display: 'none',
    },
  },
});

export const styleClasses =
  PropTypes.shape(_.mapObject(getStyles(), () => PropTypes.string));
